import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';
import { mockData, generateWhatsAppLink } from '../../mock';

const HeroSection = ({ onScrollToSection }) => {
  const { hero, brand } = mockData;

  return (
    <section className="hero-section" data-testid="home-hero-section">
      <div className="container">
        <div className="hero-content">
          <p
            className="hero-sanskrit animated fadeIn"
            lang="sa"
            data-testid="hero-sanskrit-motto"
            style={{
              fontSize: 'clamp(1.1rem, 1.8vw, 1.5rem)',
              letterSpacing: '0.08em',
              color: 'var(--brand-accent, #FFD700)',
              marginBottom: '0.75rem',
              fontWeight: 500,
            }}
          >
            {brand.sanskritMotto}
          </p>
          <p
            className="hero-motto-translation animated fadeIn delay-100ms"
            data-testid="hero-motto-translation"
            style={{
              fontSize: 'clamp(0.85rem, 1.2vw, 1rem)',
              letterSpacing: '0.3em',
              textTransform: 'uppercase',
              color: 'var(--text-light, rgba(255,255,255,0.7))',
              marginBottom: '1.5rem',
            }}
          >
            {brand.mottoTranslation}
          </p>

          <h1
            className="hero-title animated fadeIn delay-200ms"
            data-testid="hero-title"
            style={{ whiteSpace: 'pre-line' }}
          >
            {hero.headline}
          </h1>
          <p className="hero-subtitle animated fadeIn delay-300ms" data-testid="hero-subtitle">
            {hero.subheading}
          </p>

          <div className="hero-cta animated fadeIn delay-500ms">
            <Link to={hero.primaryCTALink} data-testid="hero-primary-cta">
              <Button className="btn-cta">
                {hero.primaryCTA}
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
            <Button
              className="btn-secondary ml-4"
              onClick={() => onScrollToSection('programs')}
              data-testid="hero-secondary-cta"
            >
              {hero.secondaryCTA}
            </Button>
            <Button
              className="btn-secondary ml-4"
              onClick={() => window.open(generateWhatsAppLink(), '_blank', 'noopener,noreferrer')}
              data-testid="hero-whatsapp-cta"
            >
              Chat on WhatsApp
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
